import React, { useEffect, useState } from "react";
import moment from "moment-timezone";

const MatchStatus = ({ matchTime }) => {
    const [status, setStatus] = useState("");
    const [timeLabel, setTimeLabel] = useState("");

    useEffect(() => {

        const updateStatus = () => {

            const now = moment();
            const matchMoment = moment.tz(matchTime, "America/Chicago"); // CST timezone

            const diff = matchMoment.diff(now, "minutes");

            // Determine status based on time difference
            if (diff > 0) setStatus("Upcoming");
            else if (diff <= 0 && diff > -90) setStatus("Live"); // assume match lasts 90 mins
            else setStatus("Ended");

            // Format display time
            setTimeLabel(matchMoment.format("dddd - hh:mm A z"));
        };

        updateStatus();
        const interval = setInterval(updateStatus, 60000); // update every minute
        return () => clearInterval(interval);
    }, [matchTime]);

    return (
        <div
        // className={`flex items-center gap-2 rounded-xl px-3 py-1 text-sm font-semibold ${status === "Live"
        //     ? "bg-red-600 text-white"
        //     : status === "Upcoming"
        //         ? "bg-gray-700 text-white"
        //         : "bg-gray-500 text-gray-200"
        //     }`
        // }
        >
            <span className="liveBtn">{status}</span>
            {/* <span className="bg-green-700 px-2 py-0.5 rounded-md text-xs">
                {timeLabel}
            </span> */}
        </div>
    );
};

export default MatchStatus;
